module.exports = __webpack_public_path__ + "img/rise_jeans_mid.95e25aa4.jpg";